/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Error_Updatedeal2Inputs */

const en_coinvestments_error_updatedeal2 = /** @type {(inputs: Coinvestments_Error_Updatedeal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to update deal`)
};

/**
* | output |
* | --- |
* | "Failed to update deal" |
*
* @param {Coinvestments_Error_Updatedeal2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_error_updatedeal2 = /** @type {((inputs?: Coinvestments_Error_Updatedeal2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Error_Updatedeal2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_error_updatedeal2(inputs)
});
export { coinvestments_error_updatedeal2 as "coInvestments_error_updateDeal" }